/**
 * Class description
 *
 * Created: 2017-09-18
 * @author jonas
 */
export class KitchenDramaStrings {

    //general
    public static BUTTON_TEXT_CONTINUE:string = "Continue";
    public static BUTTON_TEXT_CONTINUE_UC:string = "CONTINUE";
    public static BUTTON_TEXT_GO:string = "GO";

    public static TEXT_CLOSES_IN:string = "Closes in";
    public static TEXT_SECONDS:string = "seconds";
    public static TEXT_SECOND:string = "second";


    //Freespin intro / outro
    public static TEXT_YOU_WON_UPPER_CASE:string = "YOU WON";
    public static TEXT_YOU_WON:string = "You won:";
    public static TEXT_BBQ_SPINS:string = "BBQ SPINS";
    public static FREE_SPINS:string = "FREE SPINS";

    public static TEXT_HEAD_BBQ:string = "WILD BBQ";
    public static TEXT_INFO_BBQ:string = "In Wild BBQ Spins the meat turns into Sheriff Wilds that become walking wilds!";


    //Win field
    public static TEXT_WIN:string = "WIN";
    public static TEXT_TOTAL_WIN:string = "TOTAL WIN";
    static BUTTON_TEXT_LOADING:string = "LOADING";
    static BUTTON_TEXT_SKIP:string = "Skip";
    static KAMISABI_INTRO_TEXT:string = "Kamisabi Second Chance";
    static FREE_SPINS_INTRO_TEXT:string = "Wild Sushi Free Spins";
    static RANDOM_WILD_INTRO_TEXT:string = "Bunshin Wilds";
    static TEXT_INFO_SUSHI:string = "Extra Sushi Wilds rewarded from wins on sushi ingredients.";
    static TEXT_HEAD_SUSHI:string = "WILD SUSHI";


}